var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3048 1.92C19.8268 -0.640001 16.1317 -0.639999 14.6537 1.92L0.520191 26.4C-0.957826 28.96 0.889698 32.16 3.84573 32.16H32.1128C35.0688 32.16 36.9164 28.96 35.4383 26.4L21.3048 1.92ZM17.8113 12.9764C18.4802 12.9764 19.0183 13.5145 19.0183 14.1834V19.8162C19.0183 20.4851 18.4802 21.0233 17.8113 21.0233C17.1424 21.0233 16.6043 20.4851 16.6043 19.8162V14.1834C16.6043 13.5145 17.1424 12.9764 17.8113 12.9764ZM16.2019 24.242C16.2019 23.3534 16.9226 22.6327 17.8113 22.6327C18.7 22.6327 19.4207 23.3534 19.4207 24.242C19.4207 25.1307 18.7 25.8514 17.8113 25.8514C16.9226 25.8514 16.2019 25.1307 16.2019 24.242Z",
    fill: "url(#paint0_linear_1787_5820)",
    fillOpacity: 0.9
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1787_5820",
    x1: 38.0201,
    y1: -1.90108,
    x2: 30.4304,
    y2: 37.9548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47297F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#832A89"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.ebc2173e9e4fd3abe519a4106ae543c0.svg";
export { ForwardRef as ReactComponent };